import type { ReactNode } from 'react';

export interface PageContainerProps {
  children: ReactNode;
  /** Optional accessible label for the region. */
  ariaLabel?: string;
  className?: string;
}

/** Constrains page content to a readable width. */
export function PageContainer({ children, ariaLabel, className }: PageContainerProps) {
  return (
    <div className={['zs-container', className].filter(Boolean).join(' ')} aria-label={ariaLabel}>
      {children}
    </div>
  );
}
